export default function isUndefined(val) {
  return val === undefined;
}
